var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C7.42017 7.08096e-08 5.86817 0.415856 4.5 1.20577L6.92266 5.40195C7.53371 5.0484 8.24318 4.84605 8.9999 4.84605C11.294 4.84605 13.1537 6.70579 13.1537 8.9999L18 8.99999C18 7.42016 17.5841 5.86817 16.7942 4.5C16.0043 3.13182 14.8682 1.99568 13.5 1.20577C12.1318 0.415856 10.5798 -7.0806e-08 9 0Z",
    fill: "#03DD6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92275 12.5979L4.5 16.7942C5.86817 17.5841 7.42017 18 9 18C10.5798 18 12.1318 17.5841 13.5 16.7942C14.8682 16.0043 16.0043 14.8682 16.7942 13.5C17.5841 12.1318 18 10.5798 18 8.99999L13.1537 8.9999C13.1537 11.2939 11.2939 13.1537 8.99986 13.1537C8.24319 13.1537 7.53377 12.9514 6.92275 12.5979Z",
    fill: "#437AF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20577 13.4999C1.99568 14.8681 3.13183 16.0043 4.5 16.7942L6.92275 12.5979C5.6813 11.8796 4.84605 10.5373 4.84605 8.99985C4.84605 7.46247 5.68125 6.12021 6.92266 5.40195L4.5 1.20577C3.13183 1.99568 1.99568 3.13177 1.20577 4.49995C0.415856 5.86812 1.39866e-07 7.42011 0 8.99994C-1.39862e-07 10.5798 0.415856 12.1318 1.20577 13.4999Z",
    fill: "#FDD63C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieIcon);
export default __webpack_public_path__ + "static/media/pie-icon.65cab5ebfe670bc4add7ea04e76ddb4d.svg";
export { ForwardRef as ReactComponent };